import  toast  from "react-hot-toast";
import axios from "axios";

const serverURL = '';
const captchaSiteKey = "6LdbCmQrAAAAAGc9ZhqituZJBv9EImtSlIkqdD3P";
const domain = 'https://kreativoromok.hu'

async function loginMethod(loginData, captcha) {
    try {
      const res = await axios.post(`${serverURL}/api/auth/login`, { loginData, captcha }, { withCredentials: true });

      if (res.status === 200) {
        sessionStorage.setItem('refreshtoken', JSON.stringify({
          role: res.data.role,
          expiry: res.data.expireDateInMs
        }));
        return { success: true, role: res.data.role };
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        // Hibás hitelesítési adatok
        return { success: false, error: "Invalid credentials" };
      } else {
        // Egyéb hibák
        //console.error(err);
        toast.error('Problémába ütköztünk.');
        return { success: false, error: "An error occurred" };
      }
    }
}

const logoutMethod = async () => {
    try {
      const res = await axios.post(`${serverURL}/api/auth/logout`, {}, { withCredentials: true });
      
      if (res.status === 200) { 
        sessionStorage.removeItem("refreshtoken"); 
        return { success: true };
      }
    } catch (err) {
        console.error(err);
        return { success: false, error: "An error occurred" };
    }
    
}

const registrationMethod = async (registrationData, captcha) => {
  try {
    const res = await axios.post(`${serverURL}/api/auth/registration`, { registrationData, captcha });
    
    if (res.status === 200) {
      toast.success('A megerősítő kódot elküldtük a megadott email címre.')
      return { success: true };
    } else if (res.status === 409) {
      toast.error('Az email cím már regisztrálva van.');
      return { success: false, error: "An error occurred" };
    };

  } catch (err) {
      console.error(err);
      toast.error('Szerver hiba.');
      return { success: false, error: "An error occurred" };
  }
};

async function getAdminEmails(){
  try {
    const res = await axios.get(`${serverURL}/api/auth/emails`, { withCredentials: true });

    if (res.status === 200) {
      return res.data.results;
    }
  } catch (err) {
    console.error('Error occurred:', err.message);
    return [];
  }
};

const getPasswordToken = async (email, captcha) => {
  try {
    const res = await axios.post(`${serverURL}/api/auth/forgotpassword`, {email, captcha});
    
    if (res.status === 200) { 
      toast.success('Ha van fiókod, már úton van a jelszó-visszaállító email.', {duration: 8000});
      return { success: true };
    }
  } catch (err) {
      console.error(err);
      toast.error('Problémába ütköztünk!');
      return { success: false, error: "An error occurred" };
  }
  
};

const sendNewPassword = async (password, token) => {
  try {
    const res = await axios.post(`${serverURL}/api/auth/resetpassword/${token}`, {password});
  
    if (res.status === 200) {
      toast.success('Sikeres jelszócsere!');
    }
  } catch (err) {
    
    toast.error('Hiba történt a jelszó frissítésekor.');
  }
  
};

const verifyEmail = async (token) => {
  try {
    const res = await axios.post(`${serverURL}/api/auth/verifyemail/${token}`);
    return res;

  } catch (err) {
    //console.error(err);
    toast.error('Hiba történt az email megerősítésénél.');
    return;
  }
};

export {
    loginMethod,
    logoutMethod,
    registrationMethod,
    getAdminEmails,
    serverURL,
    domain,
    getPasswordToken,
    sendNewPassword,
    captchaSiteKey,
    verifyEmail
};